module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nfor (var i = 0; i < data.length; i++) {\n\n    var obj = data[i];\n    %>\n    <% if(obj) { %>\n        <div class=\"spotlight-carousel-wrapper\" data-video-preview-url=\"<%= obj.videoPreviewURL %>\">\n\n            <% if( ((obj.startTimestamp && obj.streamStartTimestamp && obj.streamEndTimestamp) || (obj.availableDate)) && obj.showCountdownTimer) { %>\n            <div class=\"spotlight-countdown\" data-first-available-timestamp=\"<%= obj.availableDate %>\" data-start-timestamp=\"<%= obj.startTimestamp %>\" data-stream-start-timestamp=\"<%= obj.streamStartTimestamp %>\" data-stream-end-timestamp=\"<%= obj.streamEndTimestamp %>\"></div>\n            <% } %>\n            \n            <div id=\"spotlight-player-<%= carouselId %>-<%= obj.showMovieId %>-<%= i %>\" class=\"spotlight-background-video\"></div>\n        \n            <div class=\"spotlight-background-image\">\n                <img class=\"spotlight-background-image--mobile\" src=\"<%= obj.backgroundMobileImage %>\" alt=\"<%= obj.alt %>\">\n                <img class=\"spotlight-background-image--desktop\" src=\"<%= obj.backgroundImage %>\" alt=\"<%= obj.alt %>\">\n            </div>\n            \n            <div class=\"hero__lockup\">\n                <a class=\"spotlight-link link\" href=\"<%= obj.href %>\" title=\"<%= obj.title %>\" id=\"<%= obj.id %>\"\n                    aa-link=\"<%= obj.aaLink %>\"\n                    data-fathom=\"<%= obj.fathom %>\"\n                    data-impression=\"<%= obj.impression %>\"\n                >\n                </a>\n                \n                <div class=\"hero__grid padded-container\">\n                    <h1>   \n                        <% if(obj.logoImage) { %>\n                        <div class=\"movieLogo\">\n                            <img alt=\"\" src=\"<%= obj.logoImage %>\">\n                        </div>\n                        <% } else { %>\n                        <span class=\"fall-back-title\"><%= obj.title %></span>\n                        <% } %>\n                    </h1>\n\n                    <% if(obj.category || obj.streamStartTimestamp || obj.streamEndTimestamp || obj.startTimestamp || obj.rating || obj.ratingIcon) { %>\n                    <div class=\"meta-container\">\n                        <div class=\"sub-metadata\">\n                            <% if(obj.bundleLocked) { %>\n                            <span class=\"bundle-lock\">\n                                <img src=\"/assets/images/svg/content_lock.svg\"/>\n                            </span>\n                            <% } %>\n                            <% if(obj.category) { %>\n                                <span class=\"genre\"><%= obj.category %></span>\n                            <% } %>\n                            <% if(obj.streamStartTimestamp && obj.streamEndTimestamp && obj.startTimestamp) { %>\n                                <span class=\"air-date\" \n                                    data-stream-start-timestamp=\"<%= obj.streamStartTimestamp %>\"\n                                    data-stream-end-timestamp=\"<%= obj.streamEndTimestamp %>\"\n                                    data-start-timestamp=\"<%= obj.startTimestamp %>\"\n                                    data-end-timestamp=\"<%= obj.endTimestamp %>\"\n                                ></span>\n                            <% } %>\n                            <% if(obj.rating) { %>\n                                <span class=\"rating\"><%= obj.rating %></span>\n                            <% } else if (obj.ratingIcon) { %>\n                                <img class=\"ratings-icon\" src=\"<%= obj.ratingIcon %>\">\n                            <% } %>\n                        </div>\n                    </div><!--.meta-container-->\n                    <% } %>\n    \n                    <% if (obj.tuneInTime) { %>\n                        <div class=\"callOut\"><%= obj.tuneInTime %></div>\n                    <% } %>\n                    \n                    <% if(obj.description) { %>\n                        <div class=\"description-box\">\n                            <div class=\"description\">\n                                <p><%= obj.description %></p>\n                            </div>\n                        </div><!--.description-box-->\n                    <% } %>\n\n                    <% if (obj.castNames) { %>\n                        <div class=\"spotlight-cast-wrapper\">\n                            <div class=\"spotlight-cast\">\n                                <%- obj.castNames %>\n                            </div>\n                        </div>\n                    <% } %>\n                    \n                    <div class=\"cta-box\">\n\n                        <a class=\"button link spotlight-button spotlight-button--details <%= navigator.userAgent.indexOf('Win') != -1 ? 'buttonWindows' : '' %>\"\n                            aa-link=\"<%= obj.aaLink %>\"\n                            data-fathom=\"<%= obj.fathom %>\"\n                            data-impression=\"<%= obj.impression %>\"\n                            href=\"<%= obj.href %>\"\n                            role=\"link\"\n                            id=\"<%= obj.id %>\"\n                        >\n                            <div class=\"button__text\"><%= getLocale(obj.ctaText) %></div>\n                        </a>\n\n                        <a class=\"button link playIcon spotlight-button spotlight-button--live <%= navigator.userAgent.indexOf('Win') != -1 ? 'buttonWindows' : '' %>\"\n                            aa-link=\"<%= obj.aaLink %>\"\n                            data-fathom=\"<%= obj.fathom %>\"\n                            data-impression=\"<%= obj.impression %>\"\n                            href=\"<%= obj.actionUrl %>\"\n                            role=\"link\"\n                        >\n                            <div class=\"button__text\"><%= obj.actionText %></div>\n                        </a>\n\n                        <div class=\"secondary-cta\">\n                            <% if (obj.showMovieId && !obj.isHubCarousel) { %>\n                                <div class=\"details_cta_wrapper initialized tooltip-on-hover\">\n                                    <a href=\"<%= obj.href %>\"\n                                    class=\"detailsCta button no-label\"\n                                    aa-link=\"<%= obj.aaLink %>\"\n                                    data-tracking=\"DETAILS|\"\n                                    >\n                                        <span class=\"details_cta_copy\">\n                                            <span class=\"details\">Details</span>\n                                        </span>\n                                    </a>\n                                    <span class=\"tooltip\">Go to Details</span>\n                                </div>\n                                \n                                <% if (obj.allowMyListControls) { %>\n                                    <div class=\"watchlist_wrapper tooltip-on-hover\"\n                                        <% for (var key in obj.watchListCtaContent) { %>\n                                            data-<%= key %>=\"<%= obj.watchListCtaContent[key] %>\"\n                                        <% } %>\n                                        data-content_id=\"<%= obj.showMovieId %>\"\n                                        data-content_type=\"<%= obj.showOrMovie %>\"\n                                    >\n                                        <a href=\"javascript:void(0)\" class=\"watchlistCta\"\n                                            aa-link=\"<%= obj.aaLink %>\"\n                                            data-content_type=\"<%= obj.showOrMovie %>\"\n                                            data-content_id=\"<%= obj.showMovieId %>\"\n                                        >\n                                            <span class=\"watchlist_copy\"></span>\n                                        </a>\n                                        <div class=\"tooltip\">\n                                            <span class=\"add\"><%= getLocale('add_to_my_list') %></span>\n                                            <span class=\"remove\"><%= getLocale('remove_from_my_list') %></span>\n                                        </div>\n                                    </div><!--.watchlist_wrapper-->\n                                <% } %>\n    \n                                <div class=\"content_preference_wrapper tooltip-on-hover\">\n                                    <a href=\"javascript:void(0)\" class=\"contentPreferenceCta\"\n                                       data-content-type=\"<%= obj.showOrMovie %>\"\n                                       data-notify-on=\"<%= obj.notifyOn %>\"\n                                       data-content-title=\"<%= obj.title %>\"\n                                       data-content-brand=\"<%= obj.brandSlug %>\"\n                                       data-content-id=\"<%= obj.showMovieId %>\"\n                                       data-content-genre=\"<%= obj.genre %>\"\n                                       data-content-add-url=\"/user-profile/xhr/content-preference/<%= obj.showOrMovie %>/<%= obj.showMovieId %>/add/\"\n                                       data-content-remove-url=\"/user-profile/xhr/content-preference/<%= obj.showOrMovie %>/<%= obj.showMovieId %>/remove/\"\n                                    >\n                                        <span class=\"notify_copy\"></span>\n                                    </a>\n                                    <div class=\"tooltip\">\n                                        <span class=\"add\"><%= getLocale('notify_me') %></span>\n                                        <span class=\"remove\"><%= getLocale('turn_off_notifications') %></span>\n                                    </div>\n                                </div><!--.content_preference_wrapper-->\n                            <% } %>\n                        </div><!--.secondary-cta-->\n                    </div><!--.cta-box-->\n                </div><!--.hero__grid-->\n                \n                <div class=\"bottom-right-content\">\n                    <% if (obj.brandLogo && !obj.isHubCarousel) { %>\n                    <div class=\"brand-logo\">\n                        <a href=\"/brands/<%= obj.brandSlug %>\">\n                            <img src=\"<%= obj.brandLogo %>\" alt=\"<%= obj.brandSlug %>\">\n                        </a>\n                    </div>\n                    <% } %>\n                    <% if (!CBS.Registry.region.international) { %>\n                    <button title=\"Unmute Audio\" class=\"spotlight-mute-toggle hero-volume muted\"></button>\n                    <% } %>\n                </div><!--.bottom-right-content-->\n                \n            </div><!--.hero__lockup-->\n        </div><!--.spotlight-carousel-wrapper-->\n\n        <div class=\"break\"></div>\n    <%  } %>\n<%  } %>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/carousels/__carouselSpotlight.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
for (var i = 0; i < data.length; i++) {

    var obj = data[i];
    
    ; __line = 5
    ; __append("\n    ")
    ; __line = 6
    ;  if(obj) { 
    ; __append("\n        <div class=\"spotlight-carousel-wrapper\" data-video-preview-url=\"")
    ; __line = 7
    ; __append(escapeFn( obj.videoPreviewURL ))
    ; __append("\">\n\n            ")
    ; __line = 9
    ;  if( ((obj.startTimestamp && obj.streamStartTimestamp && obj.streamEndTimestamp) || (obj.availableDate)) && obj.showCountdownTimer) { 
    ; __append("\n            <div class=\"spotlight-countdown\" data-first-available-timestamp=\"")
    ; __line = 10
    ; __append(escapeFn( obj.availableDate ))
    ; __append("\" data-start-timestamp=\"")
    ; __append(escapeFn( obj.startTimestamp ))
    ; __append("\" data-stream-start-timestamp=\"")
    ; __append(escapeFn( obj.streamStartTimestamp ))
    ; __append("\" data-stream-end-timestamp=\"")
    ; __append(escapeFn( obj.streamEndTimestamp ))
    ; __append("\"></div>\n            ")
    ; __line = 11
    ;  } 
    ; __append("\n            \n            <div id=\"spotlight-player-")
    ; __line = 13
    ; __append(escapeFn( carouselId ))
    ; __append("-")
    ; __append(escapeFn( obj.showMovieId ))
    ; __append("-")
    ; __append(escapeFn( i ))
    ; __append("\" class=\"spotlight-background-video\"></div>\n        \n            <div class=\"spotlight-background-image\">\n                <img class=\"spotlight-background-image--mobile\" src=\"")
    ; __line = 16
    ; __append(escapeFn( obj.backgroundMobileImage ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( obj.alt ))
    ; __append("\">\n                <img class=\"spotlight-background-image--desktop\" src=\"")
    ; __line = 17
    ; __append(escapeFn( obj.backgroundImage ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( obj.alt ))
    ; __append("\">\n            </div>\n            \n            <div class=\"hero__lockup\">\n                <a class=\"spotlight-link link\" href=\"")
    ; __line = 21
    ; __append(escapeFn( obj.href ))
    ; __append("\" title=\"")
    ; __append(escapeFn( obj.title ))
    ; __append("\" id=\"")
    ; __append(escapeFn( obj.id ))
    ; __append("\"\n                    aa-link=\"")
    ; __line = 22
    ; __append(escapeFn( obj.aaLink ))
    ; __append("\"\n                    data-fathom=\"")
    ; __line = 23
    ; __append(escapeFn( obj.fathom ))
    ; __append("\"\n                    data-impression=\"")
    ; __line = 24
    ; __append(escapeFn( obj.impression ))
    ; __append("\"\n                >\n                </a>\n                \n                <div class=\"hero__grid padded-container\">\n                    <h1>   \n                        ")
    ; __line = 30
    ;  if(obj.logoImage) { 
    ; __append("\n                        <div class=\"movieLogo\">\n                            <img alt=\"\" src=\"")
    ; __line = 32
    ; __append(escapeFn( obj.logoImage ))
    ; __append("\">\n                        </div>\n                        ")
    ; __line = 34
    ;  } else { 
    ; __append("\n                        <span class=\"fall-back-title\">")
    ; __line = 35
    ; __append(escapeFn( obj.title ))
    ; __append("</span>\n                        ")
    ; __line = 36
    ;  } 
    ; __append("\n                    </h1>\n\n                    ")
    ; __line = 39
    ;  if(obj.category || obj.streamStartTimestamp || obj.streamEndTimestamp || obj.startTimestamp || obj.rating || obj.ratingIcon) { 
    ; __append("\n                    <div class=\"meta-container\">\n                        <div class=\"sub-metadata\">\n                            ")
    ; __line = 42
    ;  if(obj.bundleLocked) { 
    ; __append("\n                            <span class=\"bundle-lock\">\n                                <img src=\"/assets/images/svg/content_lock.svg\"/>\n                            </span>\n                            ")
    ; __line = 46
    ;  } 
    ; __append("\n                            ")
    ; __line = 47
    ;  if(obj.category) { 
    ; __append("\n                                <span class=\"genre\">")
    ; __line = 48
    ; __append(escapeFn( obj.category ))
    ; __append("</span>\n                            ")
    ; __line = 49
    ;  } 
    ; __append("\n                            ")
    ; __line = 50
    ;  if(obj.streamStartTimestamp && obj.streamEndTimestamp && obj.startTimestamp) { 
    ; __append("\n                                <span class=\"air-date\" \n                                    data-stream-start-timestamp=\"")
    ; __line = 52
    ; __append(escapeFn( obj.streamStartTimestamp ))
    ; __append("\"\n                                    data-stream-end-timestamp=\"")
    ; __line = 53
    ; __append(escapeFn( obj.streamEndTimestamp ))
    ; __append("\"\n                                    data-start-timestamp=\"")
    ; __line = 54
    ; __append(escapeFn( obj.startTimestamp ))
    ; __append("\"\n                                    data-end-timestamp=\"")
    ; __line = 55
    ; __append(escapeFn( obj.endTimestamp ))
    ; __append("\"\n                                ></span>\n                            ")
    ; __line = 57
    ;  } 
    ; __append("\n                            ")
    ; __line = 58
    ;  if(obj.rating) { 
    ; __append("\n                                <span class=\"rating\">")
    ; __line = 59
    ; __append(escapeFn( obj.rating ))
    ; __append("</span>\n                            ")
    ; __line = 60
    ;  } else if (obj.ratingIcon) { 
    ; __append("\n                                <img class=\"ratings-icon\" src=\"")
    ; __line = 61
    ; __append(escapeFn( obj.ratingIcon ))
    ; __append("\">\n                            ")
    ; __line = 62
    ;  } 
    ; __append("\n                        </div>\n                    </div><!--.meta-container-->\n                    ")
    ; __line = 65
    ;  } 
    ; __append("\n    \n                    ")
    ; __line = 67
    ;  if (obj.tuneInTime) { 
    ; __append("\n                        <div class=\"callOut\">")
    ; __line = 68
    ; __append(escapeFn( obj.tuneInTime ))
    ; __append("</div>\n                    ")
    ; __line = 69
    ;  } 
    ; __append("\n                    \n                    ")
    ; __line = 71
    ;  if(obj.description) { 
    ; __append("\n                        <div class=\"description-box\">\n                            <div class=\"description\">\n                                <p>")
    ; __line = 74
    ; __append(escapeFn( obj.description ))
    ; __append("</p>\n                            </div>\n                        </div><!--.description-box-->\n                    ")
    ; __line = 77
    ;  } 
    ; __append("\n\n                    ")
    ; __line = 79
    ;  if (obj.castNames) { 
    ; __append("\n                        <div class=\"spotlight-cast-wrapper\">\n                            <div class=\"spotlight-cast\">\n                                ")
    ; __line = 82
    ; __append( obj.castNames )
    ; __append("\n                            </div>\n                        </div>\n                    ")
    ; __line = 85
    ;  } 
    ; __append("\n                    \n                    <div class=\"cta-box\">\n\n                        <a class=\"button link spotlight-button spotlight-button--details ")
    ; __line = 89
    ; __append(escapeFn( navigator.userAgent.indexOf('Win') != -1 ? 'buttonWindows' : '' ))
    ; __append("\"\n                            aa-link=\"")
    ; __line = 90
    ; __append(escapeFn( obj.aaLink ))
    ; __append("\"\n                            data-fathom=\"")
    ; __line = 91
    ; __append(escapeFn( obj.fathom ))
    ; __append("\"\n                            data-impression=\"")
    ; __line = 92
    ; __append(escapeFn( obj.impression ))
    ; __append("\"\n                            href=\"")
    ; __line = 93
    ; __append(escapeFn( obj.href ))
    ; __append("\"\n                            role=\"link\"\n                            id=\"")
    ; __line = 95
    ; __append(escapeFn( obj.id ))
    ; __append("\"\n                        >\n                            <div class=\"button__text\">")
    ; __line = 97
    ; __append(escapeFn( getLocale(obj.ctaText) ))
    ; __append("</div>\n                        </a>\n\n                        <a class=\"button link playIcon spotlight-button spotlight-button--live ")
    ; __line = 100
    ; __append(escapeFn( navigator.userAgent.indexOf('Win') != -1 ? 'buttonWindows' : '' ))
    ; __append("\"\n                            aa-link=\"")
    ; __line = 101
    ; __append(escapeFn( obj.aaLink ))
    ; __append("\"\n                            data-fathom=\"")
    ; __line = 102
    ; __append(escapeFn( obj.fathom ))
    ; __append("\"\n                            data-impression=\"")
    ; __line = 103
    ; __append(escapeFn( obj.impression ))
    ; __append("\"\n                            href=\"")
    ; __line = 104
    ; __append(escapeFn( obj.actionUrl ))
    ; __append("\"\n                            role=\"link\"\n                        >\n                            <div class=\"button__text\">")
    ; __line = 107
    ; __append(escapeFn( obj.actionText ))
    ; __append("</div>\n                        </a>\n\n                        <div class=\"secondary-cta\">\n                            ")
    ; __line = 111
    ;  if (obj.showMovieId && !obj.isHubCarousel) { 
    ; __append("\n                                <div class=\"details_cta_wrapper initialized tooltip-on-hover\">\n                                    <a href=\"")
    ; __line = 113
    ; __append(escapeFn( obj.href ))
    ; __append("\"\n                                    class=\"detailsCta button no-label\"\n                                    aa-link=\"")
    ; __line = 115
    ; __append(escapeFn( obj.aaLink ))
    ; __append("\"\n                                    data-tracking=\"DETAILS|\"\n                                    >\n                                        <span class=\"details_cta_copy\">\n                                            <span class=\"details\">Details</span>\n                                        </span>\n                                    </a>\n                                    <span class=\"tooltip\">Go to Details</span>\n                                </div>\n                                \n                                ")
    ; __line = 125
    ;  if (obj.allowMyListControls) { 
    ; __append("\n                                    <div class=\"watchlist_wrapper tooltip-on-hover\"\n                                        ")
    ; __line = 127
    ;  for (var key in obj.watchListCtaContent) { 
    ; __append("\n                                            data-")
    ; __line = 128
    ; __append(escapeFn( key ))
    ; __append("=\"")
    ; __append(escapeFn( obj.watchListCtaContent[key] ))
    ; __append("\"\n                                        ")
    ; __line = 129
    ;  } 
    ; __append("\n                                        data-content_id=\"")
    ; __line = 130
    ; __append(escapeFn( obj.showMovieId ))
    ; __append("\"\n                                        data-content_type=\"")
    ; __line = 131
    ; __append(escapeFn( obj.showOrMovie ))
    ; __append("\"\n                                    >\n                                        <a href=\"javascript:void(0)\" class=\"watchlistCta\"\n                                            aa-link=\"")
    ; __line = 134
    ; __append(escapeFn( obj.aaLink ))
    ; __append("\"\n                                            data-content_type=\"")
    ; __line = 135
    ; __append(escapeFn( obj.showOrMovie ))
    ; __append("\"\n                                            data-content_id=\"")
    ; __line = 136
    ; __append(escapeFn( obj.showMovieId ))
    ; __append("\"\n                                        >\n                                            <span class=\"watchlist_copy\"></span>\n                                        </a>\n                                        <div class=\"tooltip\">\n                                            <span class=\"add\">")
    ; __line = 141
    ; __append(escapeFn( getLocale('add_to_my_list') ))
    ; __append("</span>\n                                            <span class=\"remove\">")
    ; __line = 142
    ; __append(escapeFn( getLocale('remove_from_my_list') ))
    ; __append("</span>\n                                        </div>\n                                    </div><!--.watchlist_wrapper-->\n                                ")
    ; __line = 145
    ;  } 
    ; __append("\n    \n                                <div class=\"content_preference_wrapper tooltip-on-hover\">\n                                    <a href=\"javascript:void(0)\" class=\"contentPreferenceCta\"\n                                       data-content-type=\"")
    ; __line = 149
    ; __append(escapeFn( obj.showOrMovie ))
    ; __append("\"\n                                       data-notify-on=\"")
    ; __line = 150
    ; __append(escapeFn( obj.notifyOn ))
    ; __append("\"\n                                       data-content-title=\"")
    ; __line = 151
    ; __append(escapeFn( obj.title ))
    ; __append("\"\n                                       data-content-brand=\"")
    ; __line = 152
    ; __append(escapeFn( obj.brandSlug ))
    ; __append("\"\n                                       data-content-id=\"")
    ; __line = 153
    ; __append(escapeFn( obj.showMovieId ))
    ; __append("\"\n                                       data-content-genre=\"")
    ; __line = 154
    ; __append(escapeFn( obj.genre ))
    ; __append("\"\n                                       data-content-add-url=\"/user-profile/xhr/content-preference/")
    ; __line = 155
    ; __append(escapeFn( obj.showOrMovie ))
    ; __append("/")
    ; __append(escapeFn( obj.showMovieId ))
    ; __append("/add/\"\n                                       data-content-remove-url=\"/user-profile/xhr/content-preference/")
    ; __line = 156
    ; __append(escapeFn( obj.showOrMovie ))
    ; __append("/")
    ; __append(escapeFn( obj.showMovieId ))
    ; __append("/remove/\"\n                                    >\n                                        <span class=\"notify_copy\"></span>\n                                    </a>\n                                    <div class=\"tooltip\">\n                                        <span class=\"add\">")
    ; __line = 161
    ; __append(escapeFn( getLocale('notify_me') ))
    ; __append("</span>\n                                        <span class=\"remove\">")
    ; __line = 162
    ; __append(escapeFn( getLocale('turn_off_notifications') ))
    ; __append("</span>\n                                    </div>\n                                </div><!--.content_preference_wrapper-->\n                            ")
    ; __line = 165
    ;  } 
    ; __append("\n                        </div><!--.secondary-cta-->\n                    </div><!--.cta-box-->\n                </div><!--.hero__grid-->\n                \n                <div class=\"bottom-right-content\">\n                    ")
    ; __line = 171
    ;  if (obj.brandLogo && !obj.isHubCarousel) { 
    ; __append("\n                    <div class=\"brand-logo\">\n                        <a href=\"/brands/")
    ; __line = 173
    ; __append(escapeFn( obj.brandSlug ))
    ; __append("\">\n                            <img src=\"")
    ; __line = 174
    ; __append(escapeFn( obj.brandLogo ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( obj.brandSlug ))
    ; __append("\">\n                        </a>\n                    </div>\n                    ")
    ; __line = 177
    ;  } 
    ; __append("\n                    ")
    ; __line = 178
    ;  if (!CBS.Registry.region.international) { 
    ; __append("\n                    <button title=\"Unmute Audio\" class=\"spotlight-mute-toggle hero-volume muted\"></button>\n                    ")
    ; __line = 180
    ;  } 
    ; __append("\n                </div><!--.bottom-right-content-->\n                \n            </div><!--.hero__lockup-->\n        </div><!--.spotlight-carousel-wrapper-->\n\n        <div class=\"break\"></div>\n    ")
    ; __line = 187
    ;   } 
    ; __append("\n")
    ; __line = 188
    ;   } 
    ; __append("\n")
    ; __line = 189
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/carousels/__carouselSpotlight.tpl"

}